import { c as _c } from "react/compiler-runtime";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useIntl } from "react-intl";
import { useFormMode } from "forms/contexts/useFormModeContext";
import { FormModeValues } from "types/formMode";
import { Button } from "uiShadcn/button";
import { redirectToNextStep } from "./redirectFunction";
interface IProps {
  isLoading: boolean;
  isSubmitting: boolean;
  shouldRenderSecondStep: boolean;
}
export default function SubmitButton(t0) {
  const $ = _c(17);
  const {
    isLoading,
    isSubmitting,
    shouldRenderSecondStep
  } = t0;
  const {
    formatMessage
  } = useIntl();
  const formMode = useFormMode();
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  let t1;
  if ($[0] !== pathname || $[1] !== router || $[2] !== searchParams || $[3] !== shouldRenderSecondStep) {
    t1 = () => {
      if (!shouldRenderSecondStep) {
        return;
      }
      redirectToNextStep({
        router,
        pathname,
        searchParams,
        shouldRenderSecondStep,
        withCv: false
      });
    };
    $[0] = pathname;
    $[1] = router;
    $[2] = searchParams;
    $[3] = shouldRenderSecondStep;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const previewClick = t1;
  const t2 = isLoading || isSubmitting;
  let t3;
  if ($[5] !== t2) {
    t3 = {
      disabled: t2,
      dataTestId: "formSubmitButton",
      variant: "theme",
      className: "w-full md:max-w-[320px]"
    };
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const buttonProps = t3;
  const submitText = shouldRenderSecondStep ? "continue" : "send";
  const t4 = isSubmitting ? "loading" : submitText;
  let t5;
  if ($[7] !== formatMessage || $[8] !== t4) {
    t5 = formatMessage({
      id: t4
    });
    $[7] = formatMessage;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const textValue = t5;
  if (formMode === FormModeValues.Form) {
    let t6;
    if ($[10] !== buttonProps || $[11] !== textValue) {
      t6 = <Button type="submit" {...buttonProps}>{textValue}</Button>;
      $[10] = buttonProps;
      $[11] = textValue;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    return t6;
  }
  if (formMode === FormModeValues.Preview) {
    let t6;
    if ($[13] !== buttonProps || $[14] !== previewClick || $[15] !== textValue) {
      t6 = <Button type="button" {...buttonProps} onClick={previewClick}>{textValue}</Button>;
      $[13] = buttonProps;
      $[14] = previewClick;
      $[15] = textValue;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    return t6;
  }
}